const ALL_GRADES = 'All Grades';

const GRADES = [
	{
		label: ALL_GRADES,
		tile: ALL_GRADES,
		value: ALL_GRADES,
		gradeRole: ALL_GRADES,
	},
	{
		label: 'Pre-Kindergarten',
		tile: 'Pre-Kindergarten',
		value: 'pre_k',
		gradeRole: 'pkt',
	},
	{
		label: 'Kindergarten',
		tile: 'Kindergarten',
		value: 'kg',
		gradeRole: 'kt',
	},
	{
		label: '1st Grade',
		tile: '1',
		value: 'first',
		gradeRole: 'fgt',
	},
	{
		label: '2nd Grade',
		tile: '2',
		value: 'second',
		gradeRole: 'sgt',
	},
	{
		label: '3rd Grade',
		tile: '3',
		value: 'third',
		gradeRole: 'tgt',
	},
	{
		label: '4th Grade',
		tile: '4',
		value: 'fourth',
		gradeRole: 'fogt',
	},
	{
		label: '5th Grade',
		tile: '5',
		value: 'fifth',
		gradeRole: 'figt',
	},
	{
		label: '6th Grade',
		tile: '6',
		value: 'sixth',
		gradeRole: 'sigt',
	},
	{
		label: '7th Grade',
		tile: '7',
		value: 'seventh',
		gradeRole: 'segt',
	},
	{
		label: '8th Grade',
		tile: '8',
		value: 'eighth',
		gradeRole: 'egt',
	},
	{
		label: '9th Grade',
		tile: '9',
		value: 'ninth',
		gradeRole: 'ngt',
	},
	{
		label: '10th Grade',
		tile: '10',
		value: 'tenth',
		gradeRole: 'tegt',
	},
	{
		label: '11th Grade',
		tile: '11',
		value: 'eleventh',
		gradeRole: 'elgt',
	},
	{
		label: '12th Grade',
		tile: '12',
		value: 'twelfth',
		gradeRole: 'twgt',
	},
];

export default GRADES;
